

import { IChangeTracking } from "../../changeTracking/iChangeTracking";
import { rulePrecedenceDirection } from '../directives/rulesDialog/models/rulePrecedenceDirectionEnum';

export class Rule implements IChangeTracking {

    //private _ruleConditions: RuleCondition[] = [];
    private _current: any;
    constructor(private _model: any) {
        this._current = this._model ? angular.copy(this._model) : {};
    }

    get id(): number {
        return this._current.id;
    }
    set id(value: number) {
        this._current.id = value;
    }

    get name(): string {
        return this._current.name;
    }
    set name(value: string) {
        this._current.name = value;
    }

    get description(): string {
        return this._current.description;
    }
    set description(value: string) {
        this._current.description = value;
    }

    get precedence(): number {
        return this._current.precedence;
    }
    set precedence(value: number) {
        this._current.precedence = value;
    }

    get origin(): string {
        return this._current.origin;
    }
    set origin(value: string) {
        this._current.origin = value;
    }

    get originString(): string {
        return this._current.originString;
    }
    set originString(value: string) {
        this._current.originString = value;
    }

    get originCity(): string {
        return this._current.originCity;
    }
    set originCity(value: string) {
        this._current.originCity = value;
    }

    get originLocation(): string {
        return this._current.originLocation;
    }
    set originLocation(value: string) {
        this._current.originLocation = value;
    }

    get destination(): string {
        return this._current.destination;
    }
    set destination(value: string) {
        this._current.destination = value;
    }

    get destinationString(): string {
        return this._current.destinationString;
    }
    set destinationString(value: string) {
        this._current.destinationString = value;
    }

    get destinationRegionCode(): string {
        return this._current.destinationRegionCode;
    }
    set destinationRegionCode(value: string) {
        this._current.destinationRegionCode = value;
    }

    get packageType(): string {
        return this._current.packageType;
    }
    set packageType(value: string) {
        this._current.packageType = value;
    }

    get packageTypeString(): string {
        return this._current.packageTypeString;
    }
    set packageTypeString(value: string) {
        this._current.packageTypeString = value;
    }


    get packageWeightOperator(): string {
        return this._current.packageWeightOperator;
    }
    set packageWeightOperator(value: string) {
        this._current.packageWeightOperator = value;
    }

    get packageWeight(): number {
        return this._current.packageWeight;
    }
    set packageWeight(value: number) {
        this._current.packageWeight = value;
    }

    get packageWeightString(): string {
        return this._current.packageWeightString;
    }
    set packageWeightString(value: string) {
        this._current.packageWeightString = value;
    }


    get dollarValueOperator(): string {
        return this._current.dollarValueOperator;
    }
    set dollarValueOperator(value: string) {
        this._current.dollarValueOperator = value;
    }

    get dollarValue(): number {
        return this._current.dollarValue;
    }
    set dollarValue(value: number) {
        this._current.dollarValue = value;
    }

    get dollarValueString(): string {
        return this._current.dollarValueString;
    }
    set dollarValueString(value: string) {
        this._current.dollarValueString = value;
    }

    get action(): string {
        return this._current.action;
    }
    set action(value: string) {
        this._current.action = value;
    }

    get actionString(): string {
        return this._current.actionString;
    }
    set actionString(value: string) {
        this._current.actionString = value;
    }

    //get isActive(): boolean {
    //    return this._current.isActive;
    //}
    //set isActive(value: boolean) {
    //    this._current.isActive = value;
    //}



    hasChanges(): boolean {
        return !angular.equals(this._current, this._model);
    }

    revert(): void {
        this._current = angular.copy(this._model);
    }

    commit(): void {
        this._model = angular.copy(this._current);
    }

    toJson(): any {
        return this._current;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/rules/models/rule.ts
 **/